export const OPTIONS_SET = 'character.OPTIONS_SET';
export const OPTIONS_SET_COMMIT = 'character.OPTIONS_SET_COMMIT';
